import { BarChart3 } from "lucide-react";
import type { Student } from "@/lib/student.schema";
import HighSchoolScores from "./high-school-scores";
import BonusPriorityScores from "./bonus-priority-scores";
import MathPhysicsScores from "./math-physics-scores";

interface StudentScoresProps {
	student: Student;
}

export default function CCNNScores({ student }: StudentScoresProps) {
	return (
		<div className="lg:col-span-3 print:col-span-3 space-y-3">
			<div className="space-y-2">
				<div className="flex items-center gap-2 mb-2">
					<BarChart3 className="h-5 w-5 text-orange-600" />
					<span className="font-semibold text-lg text-orange-800">Điểm học bạ</span>
				</div>

				<HighSchoolScores student={student} />

				<BonusPriorityScores student={student} />

				<MathPhysicsScores student={student} />
			</div>
		</div>
	);
}
